<template>
    <div style="overflow-x: auto" class="wfull">
        <div class="board-page-wrap" v-loading="pageLoading">
            <div class="plat-cost-wrap mb10" v-if="pageFuncNames.includes('cost_funnel')">
                <el-card class="box-card">
                    <el-radio-group v-model="formItem.cost_plat" @change="getCostPanel" size="mini" class="mr20">
                        <el-radio-button v-if="allowedPlatIds.length>0" label="">整体</el-radio-button>
                        <el-radio-button v-if="allowedPlatIds.includes('1')" label="1">OPPO</el-radio-button>
                        <el-radio-button v-if="allowedPlatIds.includes('3')" label="3">vivo</el-radio-button>
                        <el-radio-button v-if="allowedPlatIds.includes('4')" label="4">华为</el-radio-button>
                        <el-radio-button v-if="allowedPlatIds.includes('7')" label="7">小米</el-radio-button>
                    </el-radio-group>
                    <div class="plat-cost-panel-wrap mt10 full-w">
                        <div class="full-w" v-loading="cost_loading">
                            <div class="div22">
                                <MONEY
                                    tit3="消耗"
                                    :myChildNow="cost.now"
                                    :myChildYesterday="cost.yesterday"
                                    :myChildChart="cost.chart"
                                    chartNum="costChart1"
                                    ref="costChart1"
                                ></MONEY>
                            </div>
                            <div class="div4">
                                <div >
                                    <RATIO :rate="costRateData.cost_rate" tit1="消耗" tit2="达线率"></RATIO>
                                </div>
                            </div>
                            <div class="div22">
                                <MONEY
                                    tit3="有效预算"
                                    :myChildNow="plan_budget.now"
                                    :myChildYesterday="plan_budget.yesterday"
                                    :myChildChart="plan_budget.chart"
                                    chartNum="costChart2"
                                    ref="costChart2"
                                ></MONEY>
                            </div>

                            <div class="div4">
                                <div >
                                    <RATIO :rate="costRateData.plan_rate" tit1="预算" tit2="利用率"></RATIO>
                                </div>
                            </div>

                            <div class="div22">
                                <MONEY
                                    tit3="账户预算"
                                    :myChildNow="(account_budget)['now']"
                                    :myChildYesterday="account_budget['yesterday']"
                                    :myChildChart="account_budget['chart']"
                                    chartNum="costChart3"
                                    ref="costChart3"
                                ></MONEY>
                            </div>

                            <div class="div4">
                                <div >
                                    <RATIO :rate="costRateData.balance_rate" tit1="余额" tit2="使用率"></RATIO>
                                </div>
                            </div>
                            <div class="div22">
                                <MONEY
                                    tit3="余额"
                                    :myChildNow="(balance)['now']"
                                    :myChildYesterday="balance['yesterday']"
                                    :myChildChart="balance['chart']"
                                    chartNum="costChart4"
                                    ref="costChart4"
                                ></MONEY>
                            </div>
                        </div>
                    </div>

                </el-card>
            </div>



            <div class="kpi-tabs-wrap" v-if="kpiTabs.length>0">
                <el-card class="kpi-tabs-content relative">
                    <span class="tab-border-padding"></span>
                    <el-tabs v-model="activeKPITab" size="small" type="card" @tab-click="changeKPITab">
                        <el-tab-pane v-if="pageFuncNames.includes('plat_kpi_tab')" label="媒体KPI" name="plat_kpi_tab">
                            <div class="kpi-form-wrap mb10">
                                <el-radio-group v-model="formItem.range_type" @change="getPlatKPIPanel" size="mini" class="mr20">
                                    <el-radio-button label="month">本月</el-radio-button>
                                    <el-radio-button label="quarter">本季</el-radio-button>
                                    <el-radio-button label="year">本年</el-radio-button>
                                </el-radio-group>
                                <el-radio-group v-model="formItem.kpi_type" @change="getPlatKPIPanel" size="mini">
                                    <el-radio-button label="1">媒体目标</el-radio-button>
                                    <el-radio-button label="2">内部目标</el-radio-button>
                                </el-radio-group>
                            </div>

                            <el-row class="plat-goal-cards" :gutter="20">
                                <el-col :span="12" v-for="(plat,index) in kpiPanelData" :key="index" >
                                    <el-card class="box-card mb20" v-loading="plat.kpi_loading">
                                        <GoalCard :data="plat" @change-active="changeKPIActiveItem" @full="fullScreen"></GoalCard>
                                    </el-card>
                                </el-col>
                            </el-row>

                        </el-tab-pane>
                        <el-tab-pane v-if="pageFuncNames.includes('group_tab')" label="集团" name="group_tab">
                            <GroupPanel ref="groupPanel" :plat-list="allowedPlatList" />
                               <TOPLIST  ref="groupTopList"  :plat-list="allowedPlatList"  istab="jituan"></TOPLIST>
                        </el-tab-pane>
                        <el-tab-pane v-if="pageFuncNames.includes('app_tab')" label="产品" name="app_tab">
                            <AppPanel ref="appPanel" :plat-list="allowedPlatList" />
                            <TOPLIST ref="appTopList"  :plat-list="allowedPlatList"  istab="chanpin"></TOPLIST>
                        </el-tab-pane>
                    </el-tabs>
                </el-card>
            </div>

            <div class="mt20">
                <el-row class="plat-goal-cards" :gutter="20">
                    <el-col :span="6" v-if="pageFuncNames.includes('plat_dapan')">
                        <MediaMarket :plat-list="allowedPlatList" />
                    </el-col>
                    <el-col :span="6" v-if="pageFuncNames.includes('custom_add')">
                        <el-card class="box-card mb20 pointer">
                            <div @click="showAddMsg" class="tac" style="height: 353px;line-height: 240px;">
                                <i class="el-icon-plus text-bold" style="font-size: 72px; color: #aaa;"></i>
                                <p class="text-color-gray font16px">更多模块,敬请期待...</p>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
            </div>

      
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import * as echarts from 'echarts';
    import dayjs from 'dayjs';
    import quarterOfYear from 'dayjs/plugin/quarterOfYear';
    import {pageMixin} from '../mixins/dashboardMixin';
    import GoalCard from './components/goalCard';
    import MONEY from "./components/money";
    import RATIO from "./components/ratio";
    import GroupPanel from "./components/groupPanel";
    import AppPanel from "./components/appPanel";
    import MediaMarket from './components/mediaMarket';
    import API from '@/api/dashboard.js';
    import TOPLIST from "./components/topList";
    dayjs.extend(quarterOfYear);
    export default {
        name: "Media",
        mixins: [pageMixin],
        components:{
            GoalCard,
            MONEY,
            RATIO,
            TOPLIST,
            GroupPanel,
            AppPanel,
            MediaMarket,
        },
        data(){
            return {
                activeKPITab:'',    //当前激活的KPI模块
                formItem:{
                    cost_plat:'',
                    range_type:'month',
                    kpi_type:'1',
                },
                kpiPanelData:[],
                KPICharts:{},


                cost_loading:false,
                //  from MaoMao
                cost: {
                    now: {},
                    yesterday: {},
                    chart: {
                        line:[],
                        date:[],
                    }
                },
                plan_budget: {
                    now: {},
                    yesterday: {},
                    chart: {
                        line:[],
                        date:[],
                    }
                },
                account_budget: {
                    now: {},
                    yesterday: {},
                    chart: {
                        line:[],
                        date:[],
                    }
                },
                balance: {
                    now: {},
                    yesterday: {},
                    chart: {
                        line:[],
                        date:[],
                    }
                },
                costRateData: {
                    cost_rate: {},
                    plan_rate: {},
                    balance_rate: {}
                },
            }
        },
        computed:{
            range_time(){
                let rageType = this.formItem.range_type;
                let startDate = dayjs().startOf(rageType).format('YYYY-MM-DD');
                let endDate = dayjs().endOf(rageType).format('YYYY-MM-DD');

                return [startDate,endDate].join('/');
            },
            kpiTabs(){
                let kpiFuncs = ['plat_kpi_tab','group_tab','app_tab'];
                return this.pageFuncNames.filter(item=>kpiFuncs.includes(item));
            },
            ...mapState({
                sidebarOpened:state => state.app.sidebar.opened,
            }),
        },
        created(){
            window.addEventListener("resize", this.resizeChart);
        },
        methods:{
            changeKPITab(){
                if(this.activeKPITab=='plat_kpi_tab'){
                    this.getPlatKPIPanel();
                }else if(this.activeKPITab=='group_tab'){
                    this.$refs.groupPanel.getPanelDate();
                    this.$refs.groupTopList.resetTopData()
                }else if(this.activeKPITab=='app_tab'){
                    this.$refs.appPanel.getPanelDate();
                    this.$refs.appTopList.resetTopData()
                }
            },
            initPageStates(){
                if(this.pageFuncNames.includes('plat_kpi_tab')){
                    this.activeKPITab = 'plat_kpi_tab';
                }else if(this.pageFuncNames.includes('group_tab')){
                    this.activeKPITab = 'group_tab';
                }else if(this.pageFuncNames.includes('app_tab')){
                    this.activeKPITab = 'app_tab';
                }
                this.kpiPanelData = this.allowedPlatList.map(item=>{
                    return {
                        plat_id:item.id,
                        kpi_loading:false,
                        detailLoading:false,
                        cost_data:[],
                        active_item:'',
                        detailData:{
                            actual_data:[],
                            predict_data:[],
                            date:[],
                        },
                        cost_type:[],
                    }
                });

                if(this.pageFuncNames.includes('cost_funnel')){
                    this.getCostPanel();
                }
                if(this.pageFuncNames.includes('plat_kpi_tab')){
                    this.getPlatKPIPanel();
                }
            },
            getPlatKPIPanel(){
                this.allowedPlatList.forEach(plat=>{
                    let platId = plat.id;
                    // this.KPICharts['plat'+platId] = null;

                    let activePanel = this.kpiPanelData.find(item=>item.plat_id==platId);
                    activePanel.kpi_loading = true;
                    API.getMediaKPI({
                        range_time:this.range_time,
                        kpi_type:this.formItem.kpi_type,
                        plat_id:platId,
                    }).then(res=>{
                        let resData = res.data||{};
                        let resPlatId = resData.plat_id;
                        let cost_data = resData.cost_data||[];
                        let cost_type = resData.cost_type||[];

                        let actionItem = this.kpiPanelData.find(item=>item.plat_id==resPlatId);
                        if(actionItem){
                            this.$set(actionItem,'cost_data',cost_data);
                            this.$set(actionItem,'cost_type',cost_type);
                            this.changeKPIActiveItem(resPlatId,cost_data[0]);
                        }
                        activePanel.kpi_loading = false;
                    },err=>{
                        console.log('getMediaKPI err',err);
                        activePanel.kpi_loading = false;
                        this.$message.error(err.info||'请求失败')
                    })
                })
            },
            fullScreen(platId){
                const element = document.getElementById('kpiDetailChart-'+platId);
                if(!element) return;
                // IE 10及以下ActiveXObject
                if (window.ActiveXObject) {
                    const WsShell = new ActiveXObject('WScript.Shell');
                    WsShell.SendKeys('{F11}');
                } else if (element.requestFullScreen) { // HTML W3C 提议
                    element.requestFullScreen();
                } else if (element.msRequestFullscreen) { // IE11
                    element.msRequestFullScreen();
                } else if (element.webkitRequestFullScreen) { // Webkit (works in Safari5.1 and Chrome 15)
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) { // Firefox (works in nightly)
                    element.mozRequestFullScreen();
                }
            },
            changeKPIActiveItem(platId,val){
                let actionItem = this.kpiPanelData.find(item=>item.plat_id==platId);
                if(!actionItem) return false;

                let actionScene = (actionItem.cost_data||[]).find(item=>item.scene_type==val.scene_type)
                actionItem.active_item = val.scene_type;
                actionItem.detailLoading = true;
                API.getMediaKPIDetail({
                    range_time:this.range_time,
                    kpi_type:this.formItem.kpi_type,
                    plat_id:platId,
                    scene_type:val.scene_type,
                }).then(res=>{
                    let resData = res.data||{};
                    actionItem.detailLoading = false;

                    if(Array.isArray(resData)&&resData.length<=0){
                        actionItem.detailData = {
                            actual_data : [],
                            predict_data:[],
                            date:[],
                            risk_msg:'',
                            target_cost:'',
                        };
                        this.initKpiDetailChart(platId);
                    }

                    if(resData.plat_id==platId&&resData.scene_type==val.scene_type){
                        actionItem.detailData = {
                            actual_data : resData.actual_data||[],
                            predict_data:resData.predict_data||[],
                            date:resData.date||[],
                            risk_msg:resData.risk_msg,
                            target_cost:actionScene.target_cost,
                        };
                        this.initKpiDetailChart(platId);
                    }
                },err=>{
                    console.log('getMediaKPIDetail',err);
                    actionItem.detailLoading = false;
                });
            },
            initKpiDetailChart(platId){
                let $chart = document.getElementById('kpiDetailChart-'+platId);
                if(!$chart) return;

                if(!this.KPICharts['plat'+platId]){
                    this.KPICharts['plat'+platId] = echarts.init($chart);
                }

                let actionItem = this.kpiPanelData.find(item=>item.plat_id==platId);
                if(!actionItem) return false;
                let detailData = actionItem.detailData||{};
                let isHasTargetCost = detailData.target_cost&&detailData.target_cost!='--';


                let actualData = detailData.actual_data||{};
                let predictData = detailData.predict_data||{};
                let dateList =  detailData.date||[];

                let actualDataList = Object.values(actualData);
                let predictDataList = dateList.map(item=>predictData[item]||0).fill(null,0,actualDataList.length-1);
                let isLastDate = actualDataList.length>0&&actualDataList.length===predictDataList.length;
                let option = {
                    backgroundColor:'#fff',
                    color:['#75cc36','#11bde6'],
                    tooltip: {
                        trigger: 'axis',
                        formatter:'{b}<br />{a}: {c0}',
                        appendToBody:false,
                    },
                    title:{
                        show:detailData.actual_data.length<=0,
                        text:'暂无数据',
                        textStyle:{
                            color: '#aaa',
                            fontSize:'12px',
                            fontWeight:'normal',
                        },
                        left:'center',
                        top:'middle',
                    },
                    legend: {
                        data: isHasTargetCost&&!isLastDate?['实际消耗','目标修正']:['实际消耗'],
                    },
                    xAxis: {
                        type: 'category',
                        data: (detailData.date||[]).map(item=>{
                            return dayjs(item).format('MM/DD')
                        }),
                        axisTick:{
                            show:false,
                        }
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel:{
                            formatter: function (value) {
                                if(value>10000) return parseInt(value/10000)+'万';
                                if(value>1000000000) return parseInt(value/1000000000)+'亿';
                                return value;
                            }
                        }
                    },
                    grid:{
                        left: '3%',
                        right: '4%',
                        bottom: '10%',
                        top:'15%',
                        containLabel: true,
                    },
                    series: [{
                            name:'实际消耗',
                            data: actualDataList,
                            type: 'line',
                            showSymbol: false,
                             smooth: true,
                            zlevel:2,
                        }].concat(isHasTargetCost?[{
                        name:'目标修正',
                        data: predictDataList,
                        type: 'line',
                        showSymbol: false,
                        smooth: true,
                    }]:[]),
                    dataZoom:[
                        {
                            type: 'slider',
                            xAxisIndex: 0,
                            height:'5%',
                            minSpan: 5,
                            bottom: '4%',
                            show:this.formItem.range_type!=='month',
                        }
                    ],
                };
                this.KPICharts['plat'+platId].setOption(option,true);

            },
            showAddMsg(){
                this.$message.warning('功能设计开发中，敬请期待...')
            },
            getCostPanel(){
                let plat = this.formItem.cost_plat;
                this.cost_loading = true;
                API.getCostData({
                    plat_id:plat,
                }).then(res=>{
                    let resData = res.data||{};

                    let costData = resData.cost||{};
                    let costChartData = costData.chart||{};
                    this.cost.now = costData.now||{};
                    this.cost.yesterday = costData.yesterday||{};
                    this.cost.chart.date = costChartData.date||[];
                    this.cost.chart.line = costChartData.line||[];

                    let planBudgetData = resData.plan_budget||{};
                    let planBudgetChartData = planBudgetData.chart||{};
                    this.plan_budget.now = planBudgetData.now||{};
                    this.plan_budget.yesterday = planBudgetData.yesterday||{};
                    this.plan_budget.chart.date = planBudgetChartData.date||[];
                    this.plan_budget.chart.line = planBudgetChartData.line||[];

                    let accountBudgetData = resData.account_budget||{};
                    let accountBudgetChartData = accountBudgetData.chart||{};
                    this.account_budget.now = accountBudgetData.now||{};
                    this.account_budget.yesterday = accountBudgetData.yesterday||{};
                    this.account_budget.chart.date = accountBudgetChartData.date||[];
                    this.account_budget.chart.line = accountBudgetChartData.line||[];

                    let balanceData = resData.balance||{};
                    let balanceChartData = balanceData.chart||{};
                    this.balance.now = balanceData.now||{};
                    this.balance.yesterday = balanceData.yesterday||{};
                    this.balance.chart.date = balanceChartData.date||[];
                    this.balance.chart.line = balanceChartData.line||[];

                    this.costRateData.plan_rate = resData.plan_rate||{};
                    this.costRateData.cost_rate = resData.cost_rate||{};
                    this.costRateData.balance_rate = resData.balance_rate||{};

                    this.$nextTick(()=>{
                        this.$refs.costChart1.initChart();
                        this.$refs.costChart2.initChart();
                        this.$refs.costChart3.initChart();
                        this.$refs.costChart4.initChart();
                    });
                    this.cost_loading = false;
                },err=>{
                    console.log('getCostData',err);
                    this.cost_loading = false;
                })
            },
            resizeChart(){
                if(this.platChart){
                    this.platChart.resize();
                }

                this.allowedPlatList.forEach(plat=>{
                    let platId = plat.id;
                    let $chart = this.KPICharts['plat'+platId];
                    $chart&&$chart.resize();
                });
            },
        },
        watch:{
            sidebarOpened(){
                setTimeout(()=>{
                    this.resizeChart();
                },200);
            },
        },
        beforeDestroy(){
            // 组件销毁之前必须先销毁ECharts实例,否则charts里的tooltip将阴魂不散
            this.allowedPlatList.forEach(plat=>{
                let platId = plat.id;
                let $chart = this.KPICharts['plat'+platId];
                $chart&&$chart.dispose();
            });

            window.removeEventListener("resize", this.resizeChart);
        },
    }
</script>

<style lang="scss" scoped>
    .board-page-wrap{
        max-width: 1920px;
        min-width: 1080px;
        position: relative;
        z-index: 1;
    }
    ::v-deep .plat-cost-wrap .el-card__body{
        padding: 10px 15px;
    }
    ::v-deep .plat-goal-cards .el-card__body{
        padding: 10px;
    }

    ::v-deep .kpi-tabs-content .el-tabs__item{
        height: 28px;
        line-height: 28px;
        padding: 0 15px;
    }

    ::v-deep .el-radio-button--mini .el-radio-button__inner{
        padding: 5px 15px;
    }

    ::v-deep .plat-cost-panel-wrap {
        .el-card__body {
            padding: 10px;
        }
    }

    .kpi-tabs-content{
        border-top: none;
    }
    ::v-deep .kpi-tabs-content>.el-card__body{
        padding-top: 0;
    }
    ::v-deep .kpi-tabs-wrap .el-tabs__header{
        left: -21px;
    }

    .div22 {
        width: 22%;
        display: inline-block;
        vertical-align: top;
    }
    .div4 {
        width: 4%;
        display: inline-block;
        vertical-align: top;
    }
    .tab-border-padding{
        display: block;
        position: absolute;
        width: 50px;
        height: 1px;
        background-color: #E4E7ED;
        right: 20px;
        top: 28px;
    }
</style>
